// 以下路由name均需要获取 com.fshows.lifecircle.app.auth.info(getAppAuthInfoServer)的权限信息,
// 因为在这里定义一个数组name
export const JurisdictionName = [
  'viewDetails', // 特价活动详情
  'marketingGame', // 营销玩法入口
  'digitalMarketing', // 营销中心入口
  'memberActivityDetail', // 会员招募活动详情
  'memberConscribe', // 会员招募入口页面
  'marketingGameList', // 全部活动列表页面
  'shopQrcodeIndex', // 门店二维码
  'multiplatformDelivery', // 配送管理
  'allOrder', // 特价订单
  'couponList', // 优惠券列表
  'marketingGame', // 特价活动
  'groupBuy', // 拼团接龙
  'gasStation', // 加油站
  'teachTrainList', // 教培行业
  'staffList', // 员工管理
  'staffDetail', // 员工详情
  'staffAdd', // 添加员工
  'staffEdit', // 修改员工
  'staffChangePassword', // 修改员工密码
  'staffQrcode', // 员工二维码
  'staffRoleList', // 角色管理
  'staffRoleDetail', // 角色详情
  'staffRoleForm', // 添加角色
  'memberList', // 会员列表
  'memberDetail', // 会员详情
  'storeDiscountList' // 门店折扣
]
